module.exports = __webpack_public_path__ + "static/kartschuur-ed87d42689d0859b2b3fcc9c7e87870b.png";